import { render, staticRenderFns } from "./VHeaderItem.vue?vue&type=template&id=45a37d3d&scoped=true&"
import script from "./VHeaderItem.vue?vue&type=script&lang=ts&"
export * from "./VHeaderItem.vue?vue&type=script&lang=ts&"
import style0 from "./VHeaderItem.vue?vue&type=style&index=0&id=45a37d3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a37d3d",
  null
  
)

export default component.exports